import { addManagerModalActionTypes } from './Constants';

export function toggleAddManagerModal(data) {
	return {
		type: addManagerModalActionTypes.TOGGLE_ADD_MANAGER_MODAL,
		payload: { data },
	};
}

export function getInstituteTeachers(groupId, queries) {
	return {
		type: addManagerModalActionTypes.GET_INSTITUTE_GROUP_TEACHERS,
		payload: { groupId, queries },
	};
}

export function getInstituteTeachersSuccess(data) {
	return {
		type: addManagerModalActionTypes.GET_INSTITUTE_GROUP_TEACHERS_SUCCESS,
		payload: { data },
	};
}

export function getInstituteTeachersError() {
	return {
		type: addManagerModalActionTypes.GET_INSTITUTE_GROUP_TEACHERS_ERROR,
	};
}

export function changeFilters(data) {
	return {
		type: addManagerModalActionTypes.CHANGE_ADD_MANAGER_MODAL_FILTERS,
		payload: { data },
	};
}

export function addInstituteTeachers(groupId, managers, callback) {
	return {
		type: addManagerModalActionTypes.ADD_INSTITUTE_GROUP_TEACHERS,
		payload: { groupId, managers, callback },
	};
}

export function addInstituteTeachersSuccess() {
	return {
		type: addManagerModalActionTypes.ADD_INSTITUTE_GROUP_TEACHERS_SUCCESS,
	};
}

export function addInstituteTeachersError() {
	return {
		type: addManagerModalActionTypes.ADD_INSTITUTE_GROUP_TEACHERS_ERROR,
	};
}

export function clearState(groupId) {
	return {
		type: addManagerModalActionTypes.CLEAR_ADD_MANAGER_MODAL_STATE,
		payload: { groupId },
	};
}
